"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsExistingTokenFromState = void 0;
var getIsExistingToken_1 = require("../../utilities/get/getIsExistingToken");
var getIsExistingTokenFromState = function (_a) {
    var _b;
    var state = _a.state;
    return (0, getIsExistingToken_1.getIsExistingToken)({
        unscopeUser: state.currentUnscopeUser || undefined,
        findToken: ((_b = state.windowMeta) === null || _b === void 0 ? void 0 : _b.firebaseMessagingToken) || undefined,
    });
};
exports.getIsExistingTokenFromState = getIsExistingTokenFromState;
